export class TableOfContents {
  headings: any[];

  constructor() {
    this.headings = [];
  }

  scan(contentElement: HTMLElement) {
    if (!contentElement) return [];

    const elements = contentElement.querySelectorAll<HTMLElement>("h1, h2, h3");
    this.headings = Array.from(elements).map((el: HTMLElement, index) => {
      return {
        index,
        text: el.innerText,
        level: parseInt(el.tagName.substring(1)),
      };
    });

    return this.headings;
  }

  generateHTML() {
    if (this.headings.length === 0) return "";

    let html = '<ul class="menu menu-sm w-full rounded-box gap-1">';
    this.headings.forEach((heading, i) => {
      const padding = (heading.level - 1) * 1.5;
      html += `
                <li>
                    <a href="#" 
                       onclick="const el = document.querySelectorAll('.tiptap-editor-canvas h1, .tiptap-editor-canvas h2, .tiptap-editor-canvas h3')[${i}]; if(el) el.scrollIntoView({behavior: 'smooth', block: 'start'}); return false;"
                       class="text-base-content/70 hover:text-primary transition-colors block truncate"
                       style="padding-left: ${heading.level === 1 ? "1rem" : 1 + padding + "rem"}">
                        ${heading.text}
                    </a>
                </li>
            `;
    });
    return html + "</ul>";
  }
}
